import Cookies from 'js-cookie';
import { setCookie } from "./index";
import { configEnum } from "../enum";
var TokenKey = configEnum.tokenKey;
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return setCookie(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}